import React, { useState } from "react";
import clsx from "clsx";
import { BlockSet, createBlockSets } from "../models/blockSets";
import "./BlockSets.css";

const initialBlockSets = createBlockSets();

type Props = {
  selectedBlockSetName: string | null;
  onBlockSetClick: (blockSet: BlockSet) => void;
};

const BlockSets = (props: Props) => {
  const { selectedBlockSetName, onBlockSetClick } = props;
  const [blockSets] = useState(initialBlockSets);

  return (
    <div className="Section BlockSets">
      {blockSets.map((blockSet: BlockSet) => (
        <div key={blockSet.name}>
          <button
            type="button"
            className={clsx({
              selected: blockSet.name === selectedBlockSetName,
            })}
            onClick={() => onBlockSetClick(blockSet)}
          >
            {blockSet.name}
          </button>
        </div>
      ))}
    </div>
  );
};

export default BlockSets;
